module.exports = __webpack_public_path__ + "assets/img/b00.e6e40549.png";